import { useState } from 'react';

const STORAGE_KEY = 'searchHistory';
const DEFAULT_MAX_ITEMS = 5;

const getKeywords = (): string[] => {
  if (typeof window === 'undefined') return [];

  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return [];
  try {
    return JSON.parse(stored);
  } catch {
    return [];
  }
};

export const useSearchHistoryTracker = (maxItems: number = DEFAULT_MAX_ITEMS) => {
  const [keywords, setKeywords] = useState<string[]>(getKeywords());

  const addKeyword = (keyword: string) => {
    if (!keyword) return;

    const currentKeywords = getKeywords();
    const newKeywords = [keyword, ...currentKeywords.filter((item) => item !== keyword)].slice(0, maxItems);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newKeywords));
    setKeywords(newKeywords);
  };

  const removeKeyword = (keyword: string) => {
    const currentKeywords = getKeywords();
    const newKeywords = currentKeywords.filter((item) => item !== keyword);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newKeywords));
    setKeywords(newKeywords);
  };

  return {
    keywords,
    addKeyword,
    removeKeyword,
  };
};
